// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QeSvu","questions":"styles_questions__2VdO3","footer":"styles_footer__2FBw8"};